export function getCurrencySymbol(customer_currency) {
    switch (customer_currency) {
        case "USD":
            return "$";
        case "GBP":
            return "£";
        case "EUR":
            return "€";
        case "JPY":
            return "¥";
    }
}
